import React from 'react';
import { Button as FluentButton, makeStyles, mergeClasses, tokens } from '@fluentui/react-components';

// Maps the legacy Button prop API onto Fluent's Button so existing call sites
// (variant: primary | secondary | danger | outline, size: sm | md | lg) keep working.
const useStyles = makeStyles({
  danger: {
    backgroundColor: tokens.colorStatusDangerBackground3,
    color: tokens.colorNeutralForegroundOnBrand,
    ':hover': {
      backgroundColor: tokens.colorStatusDangerBackground3Hover,
      color: tokens.colorNeutralForegroundOnBrand,
    },
    ':hover:active': {
      backgroundColor: tokens.colorStatusDangerBackground3Pressed,
      color: tokens.colorNeutralForegroundOnBrand,
    },
  },
});

const APPEARANCE_BY_VARIANT = {
  primary: 'primary',
  secondary: 'secondary',
  danger: 'primary',
  outline: 'outline',
};

const SIZE_BY_PROP = {
  sm: 'small',
  md: 'medium',
  lg: 'large',
};

export default function Button({
  children,
  type = 'button',
  variant = 'primary',
  size = 'md',
  disabled = false,
  onClick,
  className = '',
  ...props
}) {
  const styles = useStyles();
  const appearance = APPEARANCE_BY_VARIANT[variant] || 'primary';
  const fluentSize = SIZE_BY_PROP[size] || 'medium';
  const dangerClass = variant === 'danger' ? styles.danger : '';

  return (
    <FluentButton
      type={type}
      appearance={appearance}
      size={fluentSize}
      disabled={disabled}
      onClick={onClick}
      className={mergeClasses(dangerClass, className)}
      {...props}
    >
      {children}
    </FluentButton>
  );
}
